import React from 'react';

export default function HomeIcon({
  width = 22,
  height = 20,
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_4150_10139)">
        <path
          d="M21.4 9.8306C21.2614 10.1605 21.0192 10.3724 20.645 10.3268C20.2708 10.2812 20.0516 9.81781 19.7591 9.62255V18.3462C19.7591 19.081 18.7866 19.9894 18.0562 19.9905C13.1959 19.9566 8.32134 20.0623 3.46925 19.9371C2.84849 19.847 2.042 18.9764 2.042 18.3462V9.62255C1.74943 9.81836 1.52424 10.2823 1.15606 10.3268C0.566535 10.398 0.190136 9.76886 0.5238 9.2682L8.93224 0.732058C10.0587 -0.23031 11.6837 -0.243104 12.8294 0.690337C15.0527 2.99223 17.3407 5.23015 19.5815 7.51369C20.0604 8.00155 20.8959 8.76143 21.2778 9.2682C21.3359 9.34497 21.3408 9.42952 21.4005 9.49795V9.83116L21.4 9.8306ZM14.1821 18.6582H17.9757C18.1746 18.6582 18.4644 18.3139 18.4474 18.0964L18.4386 8.27802L12.0908 1.81458C11.3457 1.17708 10.4587 1.18265 9.71133 1.81458L3.3635 8.27802L3.35474 18.0964C3.33775 18.3139 3.62759 18.6582 3.82647 18.6582H7.62005V13.0993C7.62005 12.2482 8.69171 11.3971 9.48451 11.3281C10.2313 11.263 11.5227 11.2742 12.2765 11.3281C13.0934 11.3865 14.1816 12.2237 14.1816 13.0999V18.6588L14.1821 18.6582ZM12.8699 18.6582V13.2656C12.8699 13.032 12.4919 12.711 12.2656 12.6721C11.7533 12.5836 10.2494 12.6176 9.68997 12.6604C9.49547 12.6754 9.3311 12.7177 9.18153 12.8523C9.11195 12.9152 8.93279 13.1889 8.93279 13.2662V18.6588H12.8699V18.6582Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4150_10139">
          <rect width="21" height="20" fill="white" transform="translate(0.400024)" />
        </clipPath>
      </defs>
    </svg>
  );
}
